import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { aboutData } from '../mockData';

export const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {aboutData.title}
          </h2>
          <p className="text-xl text-gray-600">
            {aboutData.subtitle}
          </p>
        </div>

        {/* About Content */}
        <div className="max-w-6xl mx-auto">
          <div className="max-w-3xl mx-auto text-center mb-20">
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              {aboutData.description}
            </p>
            <div className="inline-block p-6 bg-teal-50 rounded-2xl border-l-4 border-teal-600 text-left">
              <p className="text-lg text-gray-800 font-medium italic">
                {aboutData.mission}
              </p>
            </div>
          </div>

          {/* Podiatrist Profile - Hero-style frame */}
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left: Framed Headshot */}
            <div className="relative flex items-center justify-center">
              <div className="relative">
                {/* Decorative background elements */}
                <div className="absolute -top-6 -left-6 w-32 h-32 bg-teal-300/40 rounded-full blur-2xl"></div>
                <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-emerald-300/40 rounded-full blur-2xl"></div>

                {/* Image container */}
                <div className="relative w-[280px] h-[340px] md:w-[340px] md:h-[420px] rounded-3xl overflow-hidden shadow-2xl ring-4 ring-white/50">
                  <img
                    src={aboutData.podiatrist.image}
                    alt={`${aboutData.podiatrist.name} - ${aboutData.podiatrist.title} at Howick Podiatry`}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Floating info card */}
                <div className="absolute -bottom-6 -left-6 md:-left-10 bg-white rounded-2xl shadow-xl p-4 md:p-5 border border-teal-100 max-w-[240px]">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-6 h-6 text-teal-600"
                      >
                        <path d="M9 12l2 2 4-4M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900 text-sm">
                        {aboutData.podiatrist.name}
                      </p>
                      <p className="text-xs text-gray-600">
                        {aboutData.podiatrist.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Bio & Qualifications */}
            <div className="space-y-6">
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">
                  Meet {aboutData.podiatrist.name}
                </h3>
                <p className="text-xl text-teal-600 font-medium">
                  {aboutData.podiatrist.title}
                </p>
              </div>

              <p className="text-gray-700 leading-relaxed text-lg">
                {aboutData.podiatrist.bio.split('\n\n').map((paragraph, idx) => (
                  <span key={idx} className="block mb-4 last:mb-0">
                    {paragraph}
                  </span>
                ))}
              </p>

              {/* Qualifications */}
              <div className="bg-teal-50 rounded-2xl p-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">
                  Qualifications & Memberships
                </h4>
                <ul className="space-y-3">
                  {aboutData.podiatrist.qualifications.map((qual, index) => (
                    <li key={index} className="flex items-start">
                      <CheckCircle2 className="w-5 h-5 text-teal-600 mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{qual}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
